import { Injectable } from '@angular/core';
import { marketingWebsiteRouterCommands } from '../utils/website-marketing-path.utils';

@Injectable({ providedIn: 'root' })
export class WebsiteMarketingPathService {
  home(): string[] {
    return marketingWebsiteRouterCommands();
  }

  to(...segments: string[]): string[] {
    return marketingWebsiteRouterCommands(...segments);
  }
}
